import { useState, useEffect, useCallback } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/providers/AuthProvider";

export interface SmsQuota {
  base_allowance: number;
  used_this_cycle: number;
  base_remaining: number;
  rollover_balance: number;
  topup_balance: number;
  total_remaining: number;
  cycle_start: string;
  cycle_end: string;
}

export const useSmsQuota = () => {
  const { user, session } = useAuth();
  const [quota, setQuota] = useState<SmsQuota | null>(null);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!user || !session?.access_token) return;
    setLoading(true);
    try {
      const { data, error } = await supabase.functions.invoke("get-sms-quota", {
        headers: { Authorization: `Bearer ${session.access_token}` },
      });
      if (!error && data?.success) {
        setQuota(data.quota as SmsQuota);
      } else if (error) {
        console.warn("get-sms-quota failed", error);
      }
    } catch (err) {
      console.error("Failed to load SMS quota", err);
    } finally {
      setLoading(false);
    }
  }, [user, session?.access_token]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { quota, loading, refresh };
};
